export const styles = {
  menuContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    alignSelf: 'flex-start',
    fontSize: '16px',
    lineHeight: '1',
    backgroundColor: '#ffffff',
    borderRadius: '4px',
    color: '#0f172a',
    boxShadow:
      '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  },
  menuButton: {
    flex: 1,
    flexShrink: 1,
    gap: '10px',
    alignSelf: 'stretch',
    padding: '8px',
    width: '100%',
    whiteSpace: 'nowrap',
    backgroundColor: '#ffffff',
    flexBasis: 0,
    color: '#0f172a',
    textAlign: 'left',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    lineHeight: '1',
    '&:hover': {
      backgroundColor: '#E2E2FC',
    },
  },
}
